import { StringField } from "../../../types/types";
import {
  TLanguageCollection,
  TPrivacyContentItems,
  TPrivacyStatementFields,
  TPrivacyStatementProps,
} from "../types/PrivacyStatement.types";

export class PrivacyStatementModel {
  private readonly fields?: TPrivacyStatementFields;

  constructor(props: TPrivacyStatementProps) {
    this.fields = props.fields;
  }

  get title(): StringField {
    return this.fields?.privacyContent?.privacyStatementTitle || {value: ''};
  }

  get items(): TPrivacyContentItems[] {
    return this.fields?.privacyContent?.items ?? [];
  }

  get itemIds(): string[] {
    return this.items?.map((item) => item.id);
  }

  get languageCollection(): TLanguageCollection[] {
    return this.fields?.languageCollection ?? [];
  }

  get changeLanguageTitle(): StringField | undefined {
    return this.fields?.changeLanguageTitle;
  }

  get defaultLanguageTitle(): StringField | undefined {
    return this.fields?.privacyContent?.languageTitle;
  }
}
